/**
 * @file  Managing preferences store
 */
import { defaultDatabaseValues, IDB__PREFERENCES__COLOR_SCHEME, IDB__PREFERENCES__NOTIFICATION_COUNTER, IDB__PREFERENCES__STORE, } from './constants';
import { getStore } from './getStore';
/**
 * Get value for database item you want
 *
 * @param databaseItemKey Key name of database item
 * @returns               Current value of database item or default if error occurs
 */
const databaseItemGet = async (databaseItemKey) => {
    try {
        const store = await getStore(IDB__PREFERENCES__STORE, 'readonly');
        // We know the type to be DatabaseItemsValue,
        // even though theoretically it doesn't have to be that,
        // which is what TypeScript complains about
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const response = store.get(databaseItemKey);
        return new Promise(resolve => {
            response.addEventListener('error', () => {
                resolve(defaultDatabaseValues[databaseItemKey]);
            });
            response.addEventListener('success', () => {
                resolve(response.result);
            });
        });
    }
    catch {
        return Promise.resolve(defaultDatabaseValues[databaseItemKey]);
    }
};
/**
 * Update stored database items (insert if not already present)
 *
 * @param databaseItemKey   Key name of database item you want to update
 * @param databaseItemValue Value that you want to update item with
 */
const databaseItemSet = async (databaseItemKey, databaseItemValue) => {
    const store = await getStore(IDB__PREFERENCES__STORE, 'readwrite');
    const response = store.put(databaseItemValue, databaseItemKey);
    return new Promise((resolve, reject) => {
        response.addEventListener('error', () => {
            reject(`Error updating the database item - ${databaseItemKey}`);
        });
        response.addEventListener('success', () => {
            resolve();
        });
    });
};
/**
 * Get whether the user has dark mode enabled
 *
 * @returns Whether the user is in dark mode
 */
export const colorSchemeGet = async () => {
    return (await databaseItemGet(IDB__PREFERENCES__COLOR_SCHEME));
};
/**
 * Update stored color scheme (insert if not already present)
 *
 * @param colorSchemeValue The scheme to store
 */
export const colorSchemeSet = async (colorSchemeValue) => {
    return await databaseItemSet(IDB__PREFERENCES__COLOR_SCHEME, colorSchemeValue);
};
/**
 * Get number of notifications
 */
export const notificationCounterGet = async () => {
    return (await databaseItemGet(IDB__PREFERENCES__NOTIFICATION_COUNTER));
};
/**
 * Set number of notifications
 *
 * @param notificationCounterValue Value to set
 */
export const notificationCounterSet = async (notificationCounterValue) => {
    return await databaseItemSet(IDB__PREFERENCES__NOTIFICATION_COUNTER, notificationCounterValue);
};
//# sourceMappingURL=preferences.js.map